export class NavigationService {
  private mainNavigationItems: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.js-main-nav-list .js-main-nav-listitem',
  );

  constructor() {
    if (this.mainNavigationItems.length) {
      this.markActive(this.mainNavigationItems);
    }
  }

  private markActive(items: NodeListOf<HTMLElement>): void {
    items.forEach((item: HTMLElement): void => {
      const anchorElement: HTMLAnchorElement | null = item.querySelector('a');

      if (
        !anchorElement ||
        !window.location.href.includes(anchorElement.getAttribute('href') ?? '')
      ) {
        return;
      }

      anchorElement.classList.add('active');
    });
  }
}
